import * as types from '@/store/mutation-types'
import { loadExploitations, createExploitation, deleteExploitation, duplicateExploitation } from '@/api/client-api'

export default {
  state: {
    exploitations: []
  },
  mutations: {
    [types.SET_EXPLOITATIONS] (state, exploitations) {
      state.exploitations = exploitations
    },
    [types.DEL_EXPLOITATION] (state, id) {
      state.exploitations.splice(state.exploitations.findIndex(e => e.id_exploitation === id), 1)
    }
  },
  actions: {
    loadExploitations: ({ commit }) => {
      commit(types.SET_EXPLOITATIONS, [])
      commit(types.SET_INFORMATION, null)
      commit(types.ADD_LOADING_MESSAGES, 'Chargement des exploitations')
      return loadExploitations()
        .then(exploitations => commit(types.SET_EXPLOITATIONS, exploitations))
        .finally(() => {
          commit(types.DEL_LOADING_MESSAGES)
        })
    },

    createExploitation: ({ commit }, payload) => {
      commit(types.ADD_LOADING_MESSAGES, "Création d'une exploitation")
      return createExploitation(payload)
        .then(response => response.id_exploitation)
        .finally(() => {
          commit(types.DEL_LOADING_MESSAGES)
        })
    },

    deleteExploitation: ({ commit, state }, id) => {
      commit(types.ADD_LOADING_MESSAGES, "Suppression d'une exploitation")
      return deleteExploitation(id)
        .then(() => {
          commit(types.DEL_EXPLOITATION, id)
        })
        .finally(() => {
          commit(types.DEL_LOADING_MESSAGES)
        })
    },

    duplicateExploitation: ({ commit }, { idExploitation, nom, idSimulations }) => {
      commit(types.ADD_LOADING_MESSAGES, "Duplication d'une exploitation")
      return duplicateExploitation(idExploitation, nom, idSimulations)
        .then(response => response.id_exploitation)
        .finally(() => {
          commit(types.DEL_LOADING_MESSAGES)
        })
    }
  }
}
